module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-37.e0c3135f.png";